import React from 'react';
import {useNavigate} from "react-router";
import Api from "../../services/Api";
import {Breadcrumb} from "../../interfaces/common";
import iconLock from "../../../assets/icons/lock-closed-outline.svg"
import flowerImg from "../../../assets/images/flower.png"

interface Props {
  breadcrumbs: Array<Breadcrumb>
}
const Header:React.FC<Props> = ({breadcrumbs}) => {
  const api = Api.getInstance();
  const navigate = api.loggedIn ? useNavigate() : null;

  const formatBreadcrumb = (breadcrumb: Breadcrumb) => {
    if (breadcrumb.url) {
      return (
        <div className="mr-2 cursor-pointer" onClick={() => navigate(breadcrumb.url)}>
          {breadcrumb.name}&nbsp;&nbsp;&gt;
        </div>
      )
    } else {
      return (
        <div className="">
          {breadcrumb.name}
        </div>
      )
    }
  }

  return (
    <div className="h-16 border-b border-my-green top-0 flex justify-between items-center fixed w-full bg-white">
      <div className="flex items-center">
        <div>
          <img className="h-16" title="Love" src={flowerImg} alt="logo"/>
        </div>
        <div className="ml-8 p-4 flex">
          {
            breadcrumbs.map((breadcrumb, index) => {
              return (
                <div key={"bc_" + index}>
                  {formatBreadcrumb(breadcrumb)}
                </div>
              )
            })
          }
        </div>
      </div>
      {
        api.loggedIn &&
          <div className="flex items-center p-4">
            <div>{api.session.firstName}</div>
            <div className="cursor-pointer ml-4" onClick={() => api.logout()}>
                <img className="icon lg" title="Logga ut" src={iconLock} alt="logga ut"/>
            </div>
          </div>
      }

    </div>
  )
}

export default Header